// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1n2V8","inner":"Footer_inner__3k7jx","nextIcon":"Footer_nextIcon__3fEo3","innerLeft":"Footer_innerLeft__1dbsL"};